import React, { useState } from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Footer from '@common/footer';
import Content from '@common/content';
import Switch from '@common/switch';
import { useToast } from '@common/toast';
import { NotificationCustomHead } from '@components/common/customHead';
import { useBasicInfo, useMarketingInfo, useUpdateMarketingInfo } from '@repository/users/useUsers';
import { useUserInfo } from '@repository/auth/useUserInfo';
import SubMenu from '../../components/mypage/common/subMenu';
import NoticeModal from '../../components/mypage/notice/noticeModal';
import NoticeConfirmModal from '../../components/mypage/notice/noticeConfirmModal';
import styles from '../../components/mypage/notice/notice.module.scss';
import { marketingInfoItem } from '@domain/constant/userType';
import useRedirectAfterLogin from '@utils/hooks/useRedirectAfterLogin';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const MyPageNoticePage = () => {
  const Toast = useToast();
  const { data: userInfo } = useUserInfo();
  const { data: basicInfo } = useBasicInfo();
  const userName = userInfo?.name;
  const { data: marketingInfo, refetch } = useMarketingInfo(!!userName);
  const { mutateAsync: updateMarketingInfo } = useUpdateMarketingInfo(refetch);
  const smsUseYn = !!marketingInfo?.smsYn;
  const emailUseYn = !!marketingInfo?.emailYn;

  const [isOpenSmsNoticeModal, setIsOpenSmsNoticeModal] = useState<boolean>(false); //sms 모달 표시 여부
  const [isOpenSmsNoticeConfirmModal, setIsOpenSmsNoticeConfirmModal] = useState<boolean>(false); //sms 확인  모달 표시 여부

  const [isOpenEmailNoticeModal, setIsOpenEmailNoticeModal] = useState<boolean>(false); //email 모달 표시 여부
  const [isOpenEmailNoticeConfirmModal, setIsOpenEmailNoticeConfirmModal] = useState<boolean>(false); //email 확인 모달 표시 여부

  const onChangeMarketingSms = () => {
    if (!basicInfo?.mobile) {
      Toast({ type: 'error', iconType: 'info', content: '핸드폰 인증 완료 후, 설정 가능합니다.' });
      return;
    }
    setIsOpenSmsNoticeModal(true);
  };

  const onChangeMarketingEmail = () => {
    setIsOpenEmailNoticeModal(true);
  };

  const onCloseNoticeConfirmModal = () => {
    setIsOpenSmsNoticeConfirmModal(false);
    setIsOpenEmailNoticeConfirmModal(false);
  };

  const onCloseNoticeModal = () => {
    setIsOpenSmsNoticeModal(false);
    setIsOpenEmailNoticeModal(false);
  };

  const onConfirmMarketingSms = async () => {
    await updateMarketingInfo({ type: marketingInfoItem.SMS, useYn: !smsUseYn });
    setIsOpenSmsNoticeModal(false);
    //sms 처리 확인 모달 오픈
    setIsOpenSmsNoticeConfirmModal(true);
  };

  const onConfirmMarketingEmail = async () => {
    await updateMarketingInfo({ type: marketingInfoItem.EMAIL, useYn: !emailUseYn });
    setIsOpenEmailNoticeModal(false);
    //email 처리 확인 모달 오픈
    setIsOpenEmailNoticeConfirmModal(true);
  };

  useRedirectAfterLogin();
  return (
    <Layout>
      <Header />
      <NotificationCustomHead />

      <Content>
        {/* 마이 페이지 정보 영역 */}
        <div className={cx('wrap')}>
          {/* 좌측 메뉴 영역 */}
          <SubMenu />

          {/* 우측 정보 영역 - 알림 관리 */}
          <div className={cx('infoArea')}>
            <strong className={cx('title')}>알림 관리</strong>

            <div className={cx('infoInner')}>
              <div className={cx('userInfoInner')}>
                <span className={cx('infoTitle')}>SMS 알림 설정</span>
                <Switch onChange={onChangeMarketingSms} checked={smsUseYn} />
              </div>
              <div className={cx('userInfoInner')}>
                <span className={cx('infoTitle')}>이메일 알림 설정</span>
                <Switch onChange={onChangeMarketingEmail} checked={emailUseYn} />
              </div>
            </div>
          </div>
        </div>
      </Content>
      <Footer />

      {/* 알림 수신 모달 */}
      {isOpenSmsNoticeModal && (
        <NoticeModal type="SMS" useYn={!smsUseYn} onClose={onCloseNoticeModal} onConfirm={onConfirmMarketingSms} />
      )}
      {isOpenEmailNoticeModal && (
        <NoticeModal
          type="EMAIL"
          useYn={!emailUseYn}
          onClose={onCloseNoticeModal}
          onConfirm={onConfirmMarketingEmail}
        />
      )}
      {isOpenEmailNoticeConfirmModal && (
        <NoticeConfirmModal type="EMAIL" useYn={emailUseYn} onClose={onCloseNoticeConfirmModal} />
      )}
      {isOpenSmsNoticeConfirmModal && (
        <NoticeConfirmModal type="SMS" useYn={smsUseYn} onClose={onCloseNoticeConfirmModal} />
      )}
    </Layout>
  );
};

export default MyPageNoticePage;
